module.exports = __webpack_public_path__ + "media/images/smart_phone/logo_mie-34b8185a79ca870321e44021669dcff9.png";